// Symbol.iterator of Matreshka.Array instances
export default function matreshkaArrayIterator() {
  var _this = this;
  var i = 0;
  var result = {
    next: function next() {
      if (i > _this.length - 1) {
        return {
          done: true
        };
      }
      return {
        done: false,
        value: _this[i++]
      };
    }
  };
  result[Symbol.iterator] = function () {
    return result;
  };
  return result;
}